module.exports = __webpack_public_path__ + "img/084.ca4490e0.png";